import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ListQuery } from '@ose/models';
import { map, Observable } from 'rxjs';

@Injectable()
export class ActivatedRouteService {

  activatedRoute = inject(ActivatedRoute);

  listParams(listParams?: ListQuery): Observable<ListQuery> {
    return this.activatedRoute.queryParams.pipe(
      map((param: Params) => {
        if (listParams === undefined) {
          listParams = {
            page: +param['page'] || 1,
            length: +param['length'] || 10
          }
        } else {
          listParams.page = +param['page'] || 1;
          listParams.length = +param['length'] || 10;
        }

        if (param['search'])
          listParams.search = param['search'];
        else
          listParams.search = undefined;

        if (param['filter'])
          listParams.filter = param['filter'];
        else
          listParams.filter = undefined;

        if (param['include'])
          listParams.include = param['include'];

        if (param['sort'])
          listParams.sort = param['sort']
        else
          listParams.sort = undefined;

        return listParams;
      })
    );
  }
}
